import api from './api';

export const getPaidSubscribeData = (page, params) => {
  return api.get('admin/PaidSubscribe', { params: { page: page, limit: 10, order: 'createdAt', direction: 'DESC', ...params } });
};

export const updatePaidSubscribe = (paidSubscribeId, update) => {
  return api.put(`admin/PaidSubscribe/item/${paidSubscribeId}`, { object: update });
};
